// Синк системного статус-бара (иконки часов/батареи/сети + фон) под тему
// приложения. Вызывается при каждом изменении resolvedTheme (toggle + cold-start).
//
// КРИТИЧНО — Capacitor StatusBar.Style КОНТРИНТУИТИВЕН:
//   Style "LIGHT" = ТЁМНЫЕ иконки (для светлого фона)
//   Style "DARK"  = СВЕТЛЫЕ иконки (для тёмного фона)
// Поэтому: light тема → "LIGHT" (тёмные иконки, читаемы на светлом),
//          dark тема  → "DARK"  (светлые иконки, читаемы на тёмном).
// Без этого синка при переключении темы иконки не перекрашиваются — на светлой
// теме остаются белыми и не читаются (симптом пользователя).
//
// Доступ — canonical `window.Capacitor.Plugins.StatusBar`, НЕ dynamic
// `import("@capacitor/status-bar")` (bare specifier падает в production WebView,
// @capacitor/* помечены external; см. lib/api-base.ts / capacitor-platform.md).
// Паттерн 1:1 из CharacterHub (stores/theme.ts syncCapacitorStatusBar).

interface StatusBarPlugin {
	setStyle(opts: { style: "DARK" | "LIGHT" }): Promise<void> | void;
	setBackgroundColor(opts: { color: string }): Promise<void> | void;
}

// Совпадают с <meta name="theme-color"> в index.html.
const STATUS_BG_LIGHT = "#ffffff";
const STATUS_BG_DARK = "#0a0a0a";

export function syncCapacitorStatusBar(theme: "light" | "dark"): void {
	if (typeof window === "undefined") return;
	const sb = (
		window as unknown as {
			Capacitor?: { Plugins?: { StatusBar?: StatusBarPlugin } };
		}
	).Capacitor?.Plugins?.StatusBar;
	if (!sb) return; // web / плагин не зарегистрирован — noop
	try {
		void Promise.resolve(sb.setStyle({ style: theme === "dark" ? "DARK" : "LIGHT" }));
		void Promise.resolve(
			sb.setBackgroundColor({ color: theme === "dark" ? STATUS_BG_DARK : STATUS_BG_LIGHT }),
		);
	} catch {
		/* sync-throw на некоторых платформах — graceful */
	}
}
